<template>
  <a-modal width="35%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>配置商品发货时间折扣</b>
    </a-divider>
    <a-button  type="primary" style="width: 20%" @click="addDay()" class="margin-bottom">
      <a-icon type="plus"/>
      添加
    </a-button>
    <a-table :data-source="deliveryTimeDiscountList" :columns="skuColumns" rowKey="day" :pagination="false" bordered>
      <div slot="discount" slot-scope="text, record">
        <a-input-number v-model="record.discount"
                        :min="0.01" :max="10" :step="0.01"
                        :formatter="(value) => `${value}`.replace(/\.00$/, '')"
                        :parser="(value) => value.replace(/\.00$/, '')"
                        :placeholder="$t('请输入')+'折扣'"  />
        <span>折</span>
      </div>
      <span slot="day" slot-scope="text, record">
         <a-input-number v-model="record.day"
                         style="width: 90%"
                         :min="0" :max="100" :step="1"
                         :placeholder="$t('请输入')+'天数'"  />
                <span>内</span>
      </span>
      <div slot="action" slot-scope="text, record" >
        <a href="javascript:void(0)" @click="delDay(record)" style="color:red;" >删除</a>
      </div>
      <div slot="discountTitle">
        折扣
        <a-tooltip>
          <template slot="title">
            <p>请输入1-10之间的数字</p>
          </template>
          <a-icon type="question-circle" />
        </a-tooltip>
      </div>
    </a-table>
  </a-modal>
</template>

<script>
import CustomDictTag from "@/components/DictCustomTag";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      deliveryTimeDiscountList:[
      ],
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      errorMessage:undefined,
      skuColumns: [
        {
          title: '预计发货天数',
          dataIndex: 'day',
          scopedSlots: {customRender: 'day'},
          key: 'skuName',
        },
        {
          slots: { title: 'discountTitle' },
          dataIndex: 'discount',
          key: 'discount',
          scopedSlots: {customRender: 'discount'}
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          key: 'action',
          slots: {title: 'addbtn', customRender: 'name'},
          scopedSlots: {customRender: 'action'}
        }
      ],
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.deliveryTimeDiscountList = [
      ]
    },
    /** 修改按钮操作 */
    show(deliveryTimeDiscountList) {
      if (deliveryTimeDiscountList && deliveryTimeDiscountList.length > 0) {
        this.deliveryTimeDiscountList = deliveryTimeDiscountList;
      }
      this.open = true
    },
    addDay() {
      const newData = {
        day: null,
        discount: 10
      };
      this.deliveryTimeDiscountList.push(newData);
    },
    delDay(record) {
      this.deliveryTimeDiscountList = this.deliveryTimeDiscountList.filter(e => e.day !== record.day);
    },
    onOk() {
      //判断有没有选择,拿到列表里选择的
      this.open = false
      this.$emit('timeDiscount', this.deliveryTimeDiscountList)
      this.reset()
    },
  }
}
</script>
